module.exports = __webpack_public_path__ + "img/instagram.746581e4.svg";